import { Injectable, inject } from '@angular/core';

import {
  USER_SCOPED_STORAGE_KEYS,
  USER_SCOPED_STORAGE_KEY_PREFIXES,
} from '../constants/storage.constants';

import { LocalStorageService } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class StorageResetService {
  private readonly localStorageService = inject(LocalStorageService);

  public clearUserScopedData(): void {
    USER_SCOPED_STORAGE_KEYS.forEach((key: string): void => {
      this.localStorageService.removeItem(key);
    });
    USER_SCOPED_STORAGE_KEY_PREFIXES.forEach((prefix: string): void => {
      this.localStorageService.removeItemsByPrefix(prefix);
    });
  }
}
